// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-expansion-panel-body {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.my-expansion-panel {
  width: 356px;
  display: block;
  margin-top: 10px;
}
.my-expansion-panel mat-expansion-panel {
  box-shadow: none !important;
  background-color: var(--formExtBackground);
  border-radius: 2px;
}
.my-expansion-panel .my-expansion-conent {
  padding-bottom: 10px !important;
  max-height: 320px;
  overflow: auto;
}
.my-expansion-panel .error {
  display: block;
  line-height: 20px;
  width: 315px;
  color: red;
  font-size: 13px;
}

.multiline {
  overflow: auto;
  max-height: 300px;
}

.address {
  width: 350px;
}

.adpu {
  width: 120px;
}

.header {
  font-size: 13px;
  padding-left: 5px;
  padding-right: 15px;
}

.expand-panel {
  display: block;
  margin: 5px 10px 10px 10px;
}
.expand-panel .my-form-field {
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/device/device-property/device-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/device/device-property/device-property.component.scss"],"names":[],"mappings":"AAAA;EACI,4BAAA;EACA,6BAAA;ACCJ;;ADEA;EACI,YAAA;EACA,cAAA;EACA,gBAAA;ACCJ;ADAI;EACI,2BAAA;EACA,0CAAA;EACA,kBAAA;ACER;ADCI;EACI,+BAAA;EACA,iBAAA;EACA,cAAA;ACCR;ADEI;EACI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;ACAR;;ADIA;EACI,cAAA;EACA,iBAAA;ACDJ;;ADIA;EACI,YAAA;ACDJ;;ADIA;EACI,YAAA;ACDJ;;ADIA;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;ACDJ;;ADIA;EACI,cAAA;EACA,0BAAA;ACDJ;ADGI;EACI,eAAA;ACDR","sourcesContent":["::ng-deep .mat-expansion-panel-body {\n    padding-left: 5px !important;\n    padding-right: 5px !important;\n}\n\n.my-expansion-panel {\n    width: 356px; \n    display: block;\n    margin-top: 10px;\n    mat-expansion-panel {\n        box-shadow: none !important;\n        background-color:var(--formExtBackground);\n        border-radius: 2px;\n    }\n\n    .my-expansion-conent {\n        padding-bottom: 10px !important;\n        max-height: 320px;\n        overflow: auto;\n    }\n\n    .error {\n        display: block;\n        line-height: 20px;\n        width: 315px;\n        color: red;\n        font-size: 13px;\n    }\n}\n\n.multiline {\n    overflow: auto;\n    max-height: 300px;\n}\n\n.address {\n    width: 350px;\n}\n\n.adpu {\n    width: 120px;\n}\n\n.header {\n    font-size: 13px;\n    padding-left: 5px;\n    padding-right: 15px;\n}\n\n.expand-panel {\n    display: block;\n    margin: 5px 10px 10px 10px;\n\n    .my-form-field {\n        margin-top: 5px;\n    }\n}","::ng-deep .mat-expansion-panel-body {\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n\n.my-expansion-panel {\n  width: 356px;\n  display: block;\n  margin-top: 10px;\n}\n.my-expansion-panel mat-expansion-panel {\n  box-shadow: none !important;\n  background-color: var(--formExtBackground);\n  border-radius: 2px;\n}\n.my-expansion-panel .my-expansion-conent {\n  padding-bottom: 10px !important;\n  max-height: 320px;\n  overflow: auto;\n}\n.my-expansion-panel .error {\n  display: block;\n  line-height: 20px;\n  width: 315px;\n  color: red;\n  font-size: 13px;\n}\n\n.multiline {\n  overflow: auto;\n  max-height: 300px;\n}\n\n.address {\n  width: 350px;\n}\n\n.adpu {\n  width: 120px;\n}\n\n.header {\n  font-size: 13px;\n  padding-left: 5px;\n  padding-right: 15px;\n}\n\n.expand-panel {\n  display: block;\n  margin: 5px 10px 10px 10px;\n}\n.expand-panel .my-form-field {\n  margin-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
